import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { map } from "rxjs/operators";
import { AccesoService } from '../acceso/acceso.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {

  razSocial: string;
  datos: any;
  readonly urlBase = environment.rutaBase;
  //readonly urlBase = "http://localhost:9090";
  header : HttpHeaders;
  idEmpresa_Factor:any;

  constructor(private http: HttpClient, private accesoService: AccesoService) {
    this.header = this.accesoService.desencriptarTOKEN();
  }

  obtenerIDEmpresa(){
    this.idEmpresa_Factor= environment.ID_EMPRESA; //JSON.parse(sessionStorage.getItem('UserActive')).id_empresa;
  }

  obtenerEmpresa(){
    this.obtenerIDEmpresa();
    let headers = this.header;

    return  this.http.get(`${this.urlBase}/empresas/g?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  obtenerDepartamento() {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.get(`${this.urlBase}/ubigeo/D?idEmpresa_Factor=${this.idEmpresa_Factor}`, {headers});
  }
  obtenerProvincia(idDepa) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.get(`${this.urlBase}/ubigeo/P?idEmpresa_Factor=${this.idEmpresa_Factor}&idDpto=${idDepa}`, { headers });
  }

  obtenerDistrito(idProv) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.get(`${this.urlBase}/ubigeo/S?idEmpresa_Factor=${this.idEmpresa_Factor}&idProv=${idProv}`, { headers });
  }

  obtenerListaProveedores(ruc?: string) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.get(`${this.urlBase}/empresa/pl?idEmpresa_Factor=${this.idEmpresa_Factor}&Num_Doc_Identificacion=${ruc}`, { headers });
  }

  obtenerListaAdquirentes(ruc?: string) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.get(`${this.urlBase}/empresa/al?idEmpresa_Factor=${this.idEmpresa_Factor}&Num_Doc_Identificacion=${ruc}`, { headers });
  }

  obtenerProveedores() {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.get(`${this.urlBase}/empresa/p?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers });
  }

  obtenerProveedoresByRuc(ruc?: string) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.get(`${this.urlBase}/empresa/p?idEmpresa_Factor=${this.idEmpresa_Factor}&Ruc=${ruc}`, { headers });
  }

  obtenerAdquirenteByRuc(ruc?: string) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.get(`${this.urlBase}/empresa/a?idEmpresa_Factor=${this.idEmpresa_Factor}&Ruc=${ruc}`, { headers });
  }

  obtenerAdquirente() {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.get(`${this.urlBase}/empresa/a?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers })
      .pipe(
        map((data) => {
          return data;
        }));
  }

  registrarEmpresa(empresa: any) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.post(`${this.urlBase}/empresa?idEmpresa_Factor=${this.idEmpresa_Factor}`, empresa, { headers })
      .pipe(
        map((data) => {
          // console.log('data', data)
          return data;
        }));
  }

  actualizarEmpresa(idempresa: string, empresa: any) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    console.log("pepe", empresa);
    return this.http.put(`${this.urlBase}/empresa/${idempresa}?idEmpresa_Factor=${this.idEmpresa_Factor}`, empresa, { headers })
      .pipe(
        map((data) => {
          // console.log('data', data)
          return data;
        }));
  }

  obtenerContactosEmpresa(id: string, data: any) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.post(`${this.urlBase}/empresa/contacto/${id}?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers })
      .pipe(
        map((data) => {
          //console.log('dataContacto', data)
          return data;
        }));
  }
  obtenerContactosEmpresa1(idEmpresa : any){
    this.obtenerIDEmpresa();
   let headers = this.header;
   return  this.http.get(`${this.urlBase}/contactoxempresa?idEmpresa_Factor=${this.idEmpresa_Factor}&idEmpresa=${idEmpresa}`,{headers})
  }

  ObtenerContacto(idContacto:any) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.get(`${this.urlBase}/empresa/contacto?idEmpresa_Factor=${this.idEmpresa_Factor}&idContacto=${idContacto}`, { headers });
  }

  agregarContacto(data: any) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.post(`${this.urlBase}/empresa/contacto?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers })
      .pipe(
        map((data) => {
          //console.log('data', data)
          return data;
        }));
  }

  actualizarContacto(idContacto: string, data: any) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.put(`${this.urlBase}/empresa/contacto/${idContacto}?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers })
      .pipe(
        map((data) => {
          //console.log('data', data)
          return data;
        }));
  }

  eliminarContacto(idContacto: number) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    let user = JSON.parse(sessionStorage.getItem('UserActive'));
    console.log(user);
    return this.http.delete(`${this.urlBase}/empresa/contacto/${idContacto}?idEmpresa_Factor=${this.idEmpresa_Factor}&Baja_Usuario=${user.Nro_Documento_Identidad}`, { headers })
      .pipe(
        map((data) => {
          //console.log('data', data)
          return data;
        }));
  }

  agregarAdjuntoEmpresa(data: any, idContacto: any) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.put(`${this.urlBase}/empresa/adjunto/FR?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers })
      .pipe(
        map((data) => {
          //console.log('data', data)
          return data;
        }));
  }

  agregarAdjunto(data: any) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.put(`${this.urlBase}/empresa/contacto/adjunto/VP?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers })
      .pipe(
        map((data) => {
          return data;
        }))

  }

  agregarAdjuntoDNI(data: any) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.put(`${this.urlBase}/empresa/contacto/adjunto/DNI?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers })
      .pipe(
        map((data) => {
          return data;
        }));
  }

  obtenerReferenciasBancariasEmpresa(idEmpresa: any) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    //console.log("asa", data);
    return this.http.get(`${this.urlBase}/empresa/CuentaBancariaEmpresa?idEmpresa_Factor=${this.idEmpresa_Factor}&idEmpresa=${idEmpresa}`, { headers });
  }
  obtenerReferenciasBancariasEmpresaCuenta(idEmpresa: any,idCuenta:any) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    //console.log("asa", data);
    return this.http.get(`${this.urlBase}/empresa/cuenta-bancaria?idEmpresa_Factor=${this.idEmpresa_Factor}&idEmpresa=${idEmpresa}&idCuenta=${idCuenta}`, { headers });
  }
  agregarReferenciaBancaria(data: string) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.post(`${this.urlBase}/empresa/cuenta-bancaria?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers })
      .pipe(
        map((data) => {
          return data;
        }));
  }

  cambiarCuentaPredeterminada(data: string, idCuenta: string) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.put(`${this.urlBase}/empresa/cuenta/${idCuenta}?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers })
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  editarReferenciaBancaria(data: string, idReferencia: string) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.put(`${this.urlBase}/empresa/cuenta-bancaria/${idReferencia}?idEmpresa_Factor=${this.idEmpresa_Factor}`, data, { headers })
      .pipe(
        map((data) => {
          //console.log('data', data)
          return data;
        }));
  }

  eliminarReferenciaBancaria(idReferencia: string) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.delete(`${this.urlBase}/empresa/cuenta-bancaria/${idReferencia}?idEmpresa_Factor=${this.idEmpresa_Factor}`, { headers })
      .pipe(
        map((data) => {
          //console.log('data', data)
          return data;
        }));
  }

  obtenerPersonaRiesgo(body: any) {
    this.obtenerIDEmpresa();
    let headers = this.header;
    return this.http.post(`${this.urlBase}/ObtenerDNI?idEmpresa_Factor=${this.idEmpresa_Factor}`, body, { headers })
      .pipe(
        map((data) => {
          return data;
        }));
  }

  subirAdjuntoReferenciaBancaria(data: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/empresa/cuentabancariaadjunto`, data, { headers });
  }
}
